import {
  createSlice,
  isFulfilled,
  isPending,
  isRejected,
} from '@reduxjs/toolkit';

import { RootState } from '../..';
import { IUser } from '../../UserSlice';
import { ICourse } from '../CoursesSlice';
import { adminGetCourseCreditTransferLogs } from './adminApi';

export interface ICourseCreditTransferLog {
  _id: string;
  student: string | IUser;
  fromCourse: string | ICourse;
  toCourse: string | ICourse;
  fromCourseTutor: string | IUser;
  toCourseTutor: string | IUser;
  fromCourseRate: number;
  toCourseRate: number;
  currency: string;
  deductedMinutes: number;
  addedMinutes: number;
  creditHours: number;
  fromCourseBalanceBefore: number;
  fromCourseBalanceAfter: number;
  toCourseBalanceBefore: number;
  toCourseBalanceAfter: number;
  transferredBy: string | IUser;
  createdAt: string;
  updatedAt: string;
}

export interface IInitialCourseCreditTransferLogsState {
  status: 'idle' | 'loading' | 'rejected';
  adminCourseCreditTransferLogs?: {
    limit?: number;
    offset?: number;
    totalDocs?: number;
    list: Array<ICourseCreditTransferLog>;
  };
}

const initialState: IInitialCourseCreditTransferLogsState = {
  status: 'idle',
  adminCourseCreditTransferLogs: undefined,
};

export const CourseCreditTransferLogsSlice = createSlice({
  initialState,
  name: 'courseCreditTransferLogs',
  reducers: {
    resetAdminCourseCreditTransferLogs: (state) => {
      state.adminCourseCreditTransferLogs = undefined;
    },
  },
  extraReducers(builder) {
    builder.addCase(
      adminGetCourseCreditTransferLogs.fulfilled,
      (state, action) => {
        const result = action.payload;

        state.adminCourseCreditTransferLogs = {
          limit: result.limit,
          offset: result.offset,
          totalDocs: result.totalDocs || 0,
          list: result.docs || [],
        };
      }
    );

    builder.addMatcher(
      isFulfilled(adminGetCourseCreditTransferLogs),
      (state) => {
        state.status = 'idle';
      }
    );

    builder.addMatcher(
      isRejected(adminGetCourseCreditTransferLogs),
      (state) => {
        state.status = 'rejected';
      }
    );

    builder.addMatcher(isPending(adminGetCourseCreditTransferLogs), (state) => {
      state.status = 'loading';
    });
  },
});

export const getCourseCreditTransferLogsState = (
  state: RootState
): RootState['courseCreditTransferLogs'] => state.courseCreditTransferLogs;

export const {
  resetAdminCourseCreditTransferLogs,
} = CourseCreditTransferLogsSlice.actions;

export * from './adminApi';
export default CourseCreditTransferLogsSlice.reducer;
